export default "__VITE_ASSET__CjIPZClz__"